/**
 * External Links
 */
export const EXTERNAL_LINKS = {
  LINKEDIN: 'https://www.linkedin.com/company/trypillian/about/',
} as const;

/**
 * Social Media Links
 */
export const SOCIAL_LINKS = {
  LINKEDIN: EXTERNAL_LINKS.LINKEDIN,
} as const;
